"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
const common_1 = require("../../../@inax/common");
let InaxSqlService = InaxSqlService_1 = class InaxSqlService {
    constructor(_http, _configuration, _profileService) {
        this._http = _http;
        this._configuration = _configuration;
        this._profileService = _profileService;
    }
    static isNullOrEmpty(inputString) {
        if (inputString === null || inputString.length === 0) {
            return true;
        }
        else {
            return false;
        }
    }
    /***********************************************************************
     *          WEB API
     * ********************************************************************/
    //Builds a command from the given arguments, execute it against the inax connection and returns an list of data.
    query(from, where = null, orderBy = null, include = null, groupBy = null, skip = 0, take = 2147483647) {
        let accessUrl = this._configuration.ServerWithApiUrl + "Sql/Query?from=" + from;
        if (!InaxSqlService_1.isNullOrEmpty(where))
            accessUrl += "&where=" + where;
        if (!InaxSqlService_1.isNullOrEmpty(include))
            accessUrl += "&include=" + include;
        if (!InaxSqlService_1.isNullOrEmpty(orderBy))
            accessUrl += "&orderBy=" + orderBy;
        if (!InaxSqlService_1.isNullOrEmpty(groupBy))
            accessUrl += "&groupBy=" + groupBy;
        if (skip > 0)
            accessUrl += "&skip=" + skip;
        if (take > 0)
            accessUrl += "&take=" + take;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map((res) => this.ExtractData(res.json()));
    }
    ExtractData(data) {
        return data.Entries;
    }
    //Builds a command from the given arguments, execute it against the inax connection and returns the count.
    count(from, where = null, groupBy = null) {
        let accessUrl = this._configuration.ServerWithApiUrl + "Sql/Count?mappingName=" + from;
        if (where != null)
            accessUrl += "&where=" + where;
        if (groupBy != null)
            accessUrl += "&groupBy=" + groupBy;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    //Adds the given entity to the table of the type typeName. With include you can handle an add in more the one tables a call
    //e.g.  if you have a Table who has childs from an other table you declare the other table as include
    add(typeName, entity, inlude) {
        let accessUrl = this._configuration.ServerWithApiUrl + "/Sql/Add?typeName=" + typeName;
        if (inlude != null)
            accessUrl += "&include=" + inlude;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, entity, { headers }).map(res => res.json());
    }
    //Adds the given entities to the table of the type typeName. With include you can handle an add in more the one tables a call
    //e.g.  if you have a Table who has childs from an other table you declare the other table as include
    addMany(typeName, entities, inlude) {
        let accessUrl = this._configuration.ServerWithApiUrl + "/Sql/AddMany?typeName=" + typeName;
        if (inlude != null)
            accessUrl += "&inlude=" + inlude;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, entities, { headers }).map(res => res.json());
    }
    //Delete the given entity from the table
    delete(typeName, entity) {
        let accessUrl = this._configuration.ServerWithApiUrl + "/Sql/Delete?typeName=" + typeName;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, entity, { headers }).map(res => res.json());
    }
    //Delete the given entities from the table
    deleteMany(typeName, entities) {
        let accessUrl = this._configuration.ServerWithApiUrl + "/Sql/DeleteMany?typeName=" + typeName;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, entities, { headers }).map(res => res.json());
    }
    //Delete all rows from the given table
    deleteAll(typeName) {
        let accessUrl = this._configuration.ServerWithApiUrl + "/Sql/DeleteAll";
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, JSON.stringify(typeName), { headers }).map(res => res.json());
    }
    //Execute an sql command
    executeSqlCommand(cmd, parameter) {
        let accessUrl = this._configuration.ServerWithApiUrl + "/Sql/ExecuteSqlCommand?cmd=" + cmd;
        if (parameter != null)
            accessUrl += "&queryParams=" + parameter;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, "", { headers }).map(res => res.json());
    }
    //Executes the CommandText against the Connection and returns an list of data. This methode is used for non inax sql connections.
    //parameters:  @name=value,@name=value
    externalQuery(sqlConnectionId, query, parameter, transactionName) {
        let accessUrl = this._configuration.ServerWithApiUrl + "/Sql/ExternalQuery?sqlConnectionId=" + sqlConnectionId + "&query=" + query;
        if (parameter != null)
            accessUrl += "&paramerter=" + parameter;
        if (transactionName != null)
            accessUrl += "&transactionName=" + transactionName;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    //Executes a Transact-SQL statement against the connection and returns the number of rows affected.  This methode is used for non inax sql connections.
    //parameters:  @name=value,@name=value
    externalNonQuery(sqlConnectionId, query, parameter, transactionName) {
        let accessUrl = this._configuration.ServerWithApiUrl + "/Sql/ExternalNonQuery?sqlConnectionId=" + sqlConnectionId + "&query=" + query;
        if (parameter != null)
            accessUrl += "&paramerter=" + parameter;
        if (transactionName != null)
            accessUrl += "&transactionName=" + transactionName;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.put(accessUrl, "", { headers }).map(res => res.json());
    }
    normalizeUri(uri) {
        return encodeURIComponent(uri);
    }
};
InaxSqlService = InaxSqlService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        common_1.InaxConfiguration,
        common_1.ProfileService])
], InaxSqlService);
exports.InaxSqlService = InaxSqlService;
var InaxSqlService_1;
